import React, { useEffect, useState } from "react";
import StandAloneInput from "../../../../../../components/stand-alone-input";
import Select from "react-select";
const Employee = props => {
    const [editJobTitleField, setEditJobTitleField] = useState(true);
    const [editWorkClsfctnField, setEditWorkClsfctnField] = useState(true);
    const [editTaxSavedReportId, setEditTaxSavedReportId] = useState(true);
    const [wcSourceOptions, setWCSourceOptions] = useState([{ value: "empInfo", label: "Employee Field" }, { value: "ccInfo", label: "Cost Center" }]);
    const [jtSourceOptions, setJTSourceOptions] = useState([{ value: "empInfo", label: "Employee Field" }, { value: "ccInfo", label: "Cost Center" }]);
    const [selectedWCSource, setSelectedWCSource] = useState({});
    const [selectedJTSource, setSelectedJTSource] = useState({});

    useEffect(() => {
        //setWCSourceOptions(tradeClassSources);
        let savedSource = props.workClsfctnSource;
        let selected = wcSourceOptions.find(src => src.value === savedSource);
        setSelectedWCSource(selected);
    }, [props.workClsfctnSource]);

    function onValueChange(e, fieldName) {

        return props.onChange(e, fieldName);
    };


    function handleWCChange(e) {
        setSelectedWCSource(e);
        return props.onChange(e, "workClsfctnSource");
    };

    function handleJTChange(e) {
        setSelectedJTSource(e);
        return props.onChange(e, "jobTitleSource");
    };

    function setEditField(field) {
        switch (field) {
            case "jobTitleField": {
                setEditJobTitleField(!editJobTitleField);
                break;
            };
            case "workClsfctnField": {
                setEditWorkClsfctnField(!editWorkClsfctnField);
                break;
            };
            case "taxReportId": {
                setEditTaxSavedReportId(!editTaxSavedReportId);
                break;
            };
        };
    };

    return (
        <div className="ec_setup_contact reg ">
            <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                <div className="input_line ssD_fiels">
                    <Select
                        options={jtSourceOptions}
                        onChange={handleJTChange}
                        value={selectedJTSource}
                    >
                    </Select>
                </div>
            </div>
            {editJobTitleField ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Job title custom field num</label>
                        <p className="repordIDCS">
                            {props.jobTitleField || "custom field for Job title"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("jobTitleField")}
                        >
                            Edit
                        </button>
                    </div>
                </div>

            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Job Title custom field num</label>
                        <StandAloneInput
                            value={props.jobTitleField}
                            placeholder={"Enter the Custom field for Job title settings"}
                            change={e => onValueChange(e, "jobTitleField", true)}
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>

                    <button className="btn reportBtn"
                        onClick={() => setEditField("jobTitleField")}
                    >
                        Close
                    </button>
                </div>
            )}
            <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                <div className="input_line ssD_fiels">
                    <Select
                        options={wcSourceOptions}
                        onChange={handleWCChange}
                        value={selectedWCSource}
                    >
                    </Select>
                </div>
            </div>
            {editWorkClsfctnField ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Work Classification custom field num</label>
                        <p className="repordIDCS">
                            {props.workClsfctnField || "Work Classification custom field"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("workClsfctnField")}
                        >
                            Edit
                        </button>
                    </div>
                </div>
            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Work Classification custom field num</label>
                        <StandAloneInput
                            value={props.workClsfctnField}
                            placeholder={"Enter the Custom field for Work Classification"}
                            change={e => onValueChange(e, "workClsfctnField", true)}
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>

                    <button className="btn reportBtn"
                        onClick={() => setEditField("workClsfctnField")}
                    >
                        Close
                    </button>
                </div>
            )}

            {editTaxSavedReportId ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Tax Report - Saved Report Id</label>
                        <p className="repordIDCS">
                            {props.taxSavedReportId || "Tax Report - Saved Report Id"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("taxReportId")}
                        >
                            Edit
                        </button>
                    </div>
                </div>
            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Tax Report - Saved Report Id</label>
                        <StandAloneInput
                            value={props.taxSavedReportId}
                            placeholder={"Enter the Saved Report Id for Tax Report"}
                            change={e => onValueChange(e, "taxReportId", true)}
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>

                    <button className="btn reportBtn"
                        onClick={() => setEditField("taxReportId")}
                    >
                        Close
                    </button>
                </div>
            )}
        </div>
    )
}

export default Employee;